import { Cuer } from 'cuer'
import * as React from 'react'

import { cx } from './core/classes.js'

/** QR code for scannable wallet addresses, payment URIs, and setup codes. */
export function Qr(props: Qr.Props) {
  const { className, size = 'medium', ...rest } = props
  return <Cuer className={cx('text-foreground', className)} size={getSize(size)} {...rest} />
}

export namespace Qr {
  /** Props for {@link Qr}. */
  export type Props = {
    /** Additional class names for the SVG root. */
    className?: string | undefined
    /** Visual size preset. @default 'medium' */
    size?: Size | undefined
    /** Encoded QR value. */
    value: string
  }

  /** QR code size. */
  export type Size = 'large' | 'medium' | 'small'
}

const sizeValue = {
  large: '180px',
  medium: '140px',
  small: '96px',
} as const satisfies Record<Qr.Size, React.CSSProperties['width']>

function getSize(size: Qr.Size): React.CSSProperties['width'] {
  return sizeValue[size]
}
